export const SET_ROLES_LOADING = 'SET_ROLES_LOADING'
export const SET_ROLES = 'SET_ROLES'
export const ADD_ROLES = 'ADD_ROLES'
export const EDIT_ROLES = 'EDIT_ROLES'
export const DELETE_ROLES = 'DELETE_ROLES'
export const SET_USER_PERMISSIONS = 'SET_USER_PERMISSIONS'
export const SET_USER_PERMISSIONS_LOADING = 'SET_USER_PERMISSIONS_LOADING'
